"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Modal = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _utils = require("../../../utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function () { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const Modal = ({
  className,
  variant,
  show,
  handleConfirm,
  handleCancel,
  confirmbuttonText,
  cancelbuttonText,
  headlineText,
  cancelIcon,
  confirmButton,
  cancelButton,
  onClose,
  content,
  ...rest
}) => {
  let baseClass = "sp-modalWrapper";
  let idName = "sp-modal";
  let ID = `${idName}--${variant}`;
  let modalClasses = (0, _classnames.default)(className, "sp-p--48 sparta-modal");
  return /*#__PURE__*/_react.default.createElement("div", {
    id: `${baseClass}--${variant}`,
    style: {
      visibility: show ? "visible" : "hidden"
    },
    className: modalClasses
  }, /*#__PURE__*/_react.default.createElement("div", _extends({
    id: ID,
    className: `${ID} sparta-modal-content`
  }, rest), /*#__PURE__*/_react.default.createElement("div", {
    className: "sp-modal--header"
  }, /*#__PURE__*/_react.default.createElement("h3", {
    className: "sp-typography-section-title"
  }, headlineText), !cancelIcon ? /*#__PURE__*/_react.default.createElement("a", {
    href: "#",
    onClick: onClose,
    className: "X--small delete"
  }, "\xD7") : {
    cancelIcon
  }), /*#__PURE__*/_react.default.createElement("hr", {
    className: "sp-modalLine-small"
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "sp-modal--body"
  }, /*#__PURE__*/_react.default.createElement("p", {
    className: "sp-typography-body-text2"
  }, content)), /*#__PURE__*/_react.default.createElement("div", {
    className: "sp-modal--footer"
  }, cancelButton ? {
    cancelButton
  } : /*#__PURE__*/_react.default.createElement("a", {
    href: "#",
    className: "sp-modal--cancel",
    onClick: handleCancel
  }, " ", cancelbuttonText), confirmButton ? {
    confirmButton
  } : /*#__PURE__*/_react.default.createElement("a", {
    href: "#",
    onClick: handleConfirm,
    className: "sp-button sp-button--sm sp-button--primary-blue"
  }, confirmbuttonText, " "))));
};

exports.Modal = Modal;
Modal.defaultProps = {
  cancelbuttonText: "Cancel",
  confirmbuttonText: "Confirm",
  headlineText: "Headline",
  show: false,
  content: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Tellusamet malesuada morbi augue at auctor placerat. Blanditerafeugiat"
};
Modal.propTypes = {
  className: _propTypes.default.string,
  variant: _propTypes.default.oneOf(_utils.enums.modalVariants),
  show: _propTypes.default.bool,
  handleConfirm: _propTypes.default.func,
  handleCancel: _propTypes.default.func,
  cancelbuttonText: _propTypes.default.string,
  confirmbuttonText: _propTypes.default.string,
  headlineText: _propTypes.default.string,
  cancelIcon: _propTypes.default.element,
  onClose: _propTypes.default.func,
  content: _propTypes.default.string,
  confirmButton: _propTypes.default.element,
  cancelButton: _propTypes.default.element
};
var _default = Modal;
exports.default = _default;